import { useCallback } from 'react'

import { useUsersListByEmailsApi } from 'api/users/queries/useUsersListByEmailsApi'
import { useFetchUsersListByEmails } from 'api/users/queryFetchers/useFetchUsersListByEmails'
import { PageSize } from 'constants/pageSize'
import { TableDefaults } from 'constants/table'

export const useUsersAdditionalDataForLoader = () => {
  const handleFetchUsersExternalStatus = useFetchUsersListByEmails({
    staleTime: TableDefaults.LoaderStaleTime,
  })
  return useCallback(
    async (members: { email: string }[]) => {
      const usersRequest =
        members.length > 0 &&
        (await handleFetchUsersExternalStatus({
          emails: members.map(user => user.email),
          offset: 0,
          limit: PageSize.All,
        }))

      const users = usersRequest ? usersRequest.data.data : []

      return new Map(
        users.map(({ email, isExternal, synced, firstname, lastname }) => [
          email,
          { isExternal, synced, firstname, lastname },
        ]),
      )
    },
    [handleFetchUsersExternalStatus],
  )
}

export const useUsersAdditionalData = (members: { email: string }[]) => {
  const { data: usersRequest, isLoading } = useUsersListByEmailsApi({
    enabled: members.length > 0,
    params: { emails: members.map(user => user.email), offset: 0, limit: PageSize.All },
  })

  const users = usersRequest ? usersRequest.data : []

  return {
    isLoading,
    data: new Map(
      users?.map(({ email, isExternal, synced, firstname, lastname }) => [
        email,
        { isExternal, synced, firstname, lastname },
      ]),
    ),
  }
}
